function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2.25 9C2.25 6.51472 4.26472 4.5 6.75 4.5H20.25C22.7353 4.5 24.75 6.51472 24.75 9V9.5625C24.75 9.87316 24.4982 10.125 24.1875 10.125L2.8125 10.125C2.50184 10.125 2.25 9.87316 2.25 9.5625V9ZM2.8125 12.375C2.50184 12.375 2.25 12.6268 2.25 12.9375V18C2.25 20.4853 4.26472 22.5 6.75 22.5H20.25C22.7353 22.5 24.75 20.4853 24.75 18V12.9375C24.75 12.6268 24.4982 12.375 24.1875 12.375L2.8125 12.375ZM14.625 16.875C14.625 16.2537 15.1287 15.75 15.75 15.75H19.125C19.7463 15.75 20.25 16.2537 20.25 16.875C20.25 17.4963 19.7463 18 19.125 18H15.75C15.1287 18 14.625 17.4963 14.625 16.875Z"
});

var SvgWalletFill = function SvgWalletFill(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    ref: svgRef
  }, props), React.createElement("title", null, title), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgWalletFill, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/wallet-fill.bce90ea6.svg";
export { ForwardRef as ReactComponent };